export default __webpack_public_path__ + "5d06a5eaa9e78f7af563dd14b2a0ef15.png";